import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsOffer = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
      <polygon  points="20.5257446 5.7895452 9.4387967 5.7895452 9.4387967 5.7895467 9.4387967 6.7569566 20.5257446 6.7569566 20.5257446 5.7895452"/>
  <polygon points="4.720057 20.3633516 6.2976099 19.219626 7.8635631 20.3540727 7.3369386 18.5004475 8.858814 17.3196022 6.940231 17.3196022 6.2906504 15.500776 5.6758688 17.3451209 3.7155273 17.3451209 5.2791612 18.5027669 4.720057 20.3633516"/>
  <polygon points="4.720057 14.5310452 6.2976099 13.3571609 7.8635631 14.5240857 7.3369386 12.6379824 8.8704122 11.4803364 6.9402296 11.4803364 6.2929698 9.6313513 5.6758688 11.4803364 3.7155273 11.4803364 5.2791598 12.6379824 4.720057 14.5310452"/>
  <polygon points="4.720057 8.6569804 6.2976099 7.5132549 7.8635631 8.6500209 7.3369386 6.7963957 8.858814 5.6155519 6.940231 5.6155519 6.2929712 3.7665668 5.6758688 5.6155519 3.727127 5.6155519 5.2791612 6.7963957 4.720057 8.6569804"/>
  <rect x="9.4387967" y="11.6288111" width="11.086948" height=".9674114"/>
  <rect x="9.4387967" y="17.493597" width="11.086948" height=".9674114"/>
  <path d="M.356268.3191489v23.3617021h23.2874641V.3191489H.356268ZM22.67864,22.6160037H1.3236779V1.3863185h21.3549621v21.2296852Z"/>  </g>  </SvgIcon>
  );
});

export default AppIconsOffer;
